import { DataBean } from "../DataBean";

export class ReleaseProdOrder extends DataBean {



    public async releaseProductionOrderFromProductionPlan(idProductionOrder: any, productionOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_releaseProductionOrderFromProductionPlan_Number_java.util.Date", [idProductionOrder, productionOrderDate]);
    }

}